import { Box, Flex, Text } from '@chakra-ui/react';

type Option = {
  value: string;
  label: string;
};

type MultiSwitchProps = {
  options: Option[];
  /** The selected option. Owned by the caller, so the switch also follows changes it did not start. */
  value: string;
  onChange: (val: string) => void;
};

export const MultiSwitch = ({ options, value, onChange }: MultiSwitchProps) => {
  return (
    <Flex
      borderRadius="full"
      overflow="hidden"
      border="1px solid"
      borderColor="gray.500"
      bg="transparent"
      userSelect="none"
    >
      {options.map((opt, idx) => {
        const isSelected = value === opt.value;
        const handleClick = () => {
          if (!isSelected) onChange(opt.value);
        };

        return (
          <Box
            key={opt.value}
            flex="1"
            position="relative"
            bg={isSelected ? 'primary.600' : 'transparent'}
            color={isSelected ? 'white' : 'white.400'}
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor={!isSelected ? 'pointer' : 'default'}
            transition="background 0.15s"
            borderRight={idx !== options.length - 1 ? '1px solid' : undefined}
            borderColor="primary.600"
            onClick={handleClick}
            px="2"
            py="0.5"
          >
            <Text position="relative" zIndex={2} fontWeight="bold" fontSize="xs" whiteSpace="nowrap">
              {opt.label}
            </Text>
          </Box>
        );
      })}
    </Flex>
  );
};
